var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-10"},[_c('div',{staticClass:"blog-post single-post"},[_c('div',{staticClass:"blog-post-content"},[_vm._t("default")],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }